export default __webpack_public_path__ + "static/media/new-close-icon-mobile.a2a356c9.svg";